import React from "react";

const SubAlert = ({ subname, absolute }) => {
  return (
    <>
      <div
        className={`${
          absolute && "absolute"
        } flex inset-0  text-white bg-opacity-50 bg-black text-xs   items-center justify-center font-bold  sm:text-base sm:leading-3`}
      >
        <span className=" bg-black bg-opacity-80 rounded-full border px-3 py-2 ">
          {" "}
          Access with {subname} account
        </span>
      </div>
    </>
  );
};

const Visibility = ({ content, absolute, currentUser }) => {
  return (
    <>
      {"public" !== content.visibility && !currentUser ? (
        <SubAlert subname={""} absolute={absolute} />
      ) : "free" === content.visibility && !currentUser ? (
        <SubAlert subname={"free"} absolute={absolute} />
      ) : "basic" === content.visibility && currentUser.role === "free" ? (
        <SubAlert subname={"basic"} absolute={absolute} />
      ) : "premium" === content.visibility &&
        currentUser.role === "free" &&
        currentUser.role === "basic" ? (
        <SubAlert subname={"premium"} absolute={absolute} />
      ) : null}

      {"public" === content.visibility && <div></div>}
    </>
  );
};

export default Visibility;
